import { Component, OnInit } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-panel-widget',
  templateUrl: './panel-widget.component.html',
  styleUrls: ['./panel-widget.component.scss'],
})
export class PanelWidgetComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
